import React from 'react';
import { Button, MobilePromptBody, Prompt, PromptBody } from '@emarketer/componentlibrary';
import Track from '../../../helpers/AnalyticsTracker';
import { useWindowSize } from '../../../helpers/hooks/useWindowSize';
import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../../theme/constants';
import config from '../../../config';
import { getUtmsForProPlus } from '../../../helpers/UtmHelper';

const LockedComparativeEstimates: React.FC = () => {
  const isMobile = useWindowSize().isMobile;

  const productsPageUrl = `${config.publicSiteUrl}/products/`;

  const learnMoreOnClick = () => {
    Track('ComparativeEstimates-LearnMore');
    window.open(productsPageUrl, '_blank');
  };

  const footerButtons = [
    <Button key="learn-more" callback={() => learnMoreOnClick()} buttonType="white" size="m">
      Learn More
    </Button>,
    <Button
      buttonType="default"
      size="m"
      key="demo"
      as="a"
      href={`${config.publicSiteUrl}/pro-plus/${getUtmsForProPlus()}`}
      dataAnalytics="Forecasts-ValueProposition-GetADemo"
      id="Forecasts-ValueProposition-GetADemo"
    >
      Get a Demo
    </Button>,
  ];

  const message = (
    <>
      <LockedLink href={productsPageUrl}>Get a PRO+ subscription to unlock this feature.</LockedLink>
      <LockedMessage>
        Listed third party data allows you to view EMARKETER forecasts against other forecasts in one place.
      </LockedMessage>
    </>
  );

  return (
    <LockedComparativeEstimatesWrapper>
      <Prompt title={''} isMobile={isMobile} footerButtons={footerButtons}>
        {isMobile ? (
          <MobilePromptBody.TitleMessageJSXImage
            header="Third Party Data"
            message={message}
            image={
              <div style={{ marginTop: '24px' }}>
                <img width="162" height="162" alt="Locked Logo" src="/forecasts/images/lock.svg" />
              </div>
            }
          />
        ) : (
          <PromptBody.TitleMessageJSXImage
            flexToImage={true}
            header="Third Party Data"
            message={message}
            image={<img width="162" height="162" alt="Locked Logo" src="/forecasts/images/lock.svg" />}
          />
        )}
      </Prompt>
    </LockedComparativeEstimatesWrapper>
  );
};

const LockedLink = styled.a`
  text-decoration: none;
  color: ${COLOR.BLUE};
  ${TYPOGRAPHY.BOLD}

  &:hover {
    text-decoration: underline;
  }
`;

const LockedMessage = styled.p`
  ${TYPOGRAPHY.LIGHT}
`;

const LockedComparativeEstimatesWrapper = styled.div`
  border: 1px ${COLOR.LIGHTGREY} solid;
  box-shadow: 0px 16px 24px 0px #00000014;
`;

export default LockedComparativeEstimates;
